<template>
  <div>
    <PageHead title="审批流管理"></PageHead>
    <div class="oa-layout-content">
      <!-- 搜索 -->
      <!-- <div class="activiti-serach">
      <a-form-model
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <div class="search-flex">
          <span class="search-lable">审批流名称：</span>
          <a-input
            class="a-input-70"
            v-model="form.name"
            placeholder="请输入审批流名称"
          />
        </div>
      </a-form-model>
      <a-button type="primary" @click="activitiSubmit">提交</a-button>
    </div> -->
      <!-- 操作按钮组 -->
      <div class="activiti-btns">
        <a-button type="primary" @click="uploadBtn">
          <a-icon type="upload" />上传流程文件
        </a-button>
        <a-upload
          name="file"
          :multiple="false"
          :headers="headers"
          action="#"
          :fileList="bfileList"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          @change="upgrade"
        >
          <a-button type="primary" :style="{ marginLeft: '8px' }">
            <a-icon type="rise" />升级
          </a-button>
        </a-upload>
        <!-- <router-link to="/createActiviti" target="_blank">
        <a-button type="primary" :style="{ marginLeft: '8px' }">
          <a-icon type="branches" />创建审批流
        </a-button>
      </router-link> -->
      </div>
      <!-- 操作按钮组 -->
      <!-- 表格 -->
      <div class="activiti-table">
        <a-table
          rowKey="uid"
          :pagination="false"
          :loading="isLoading"
          :columns="columns"
          :data-source="data"
        >
          <div slot="operationbtn" slot-scope="text, record">
            <a @click="activitiConfig(text, record)">流程图</a>
            <a-divider type="vertical" />
            <a @click="activitiDel(text, record)">删除</a>
          </div>
        </a-table>
        <!-- 分页 -->
        <div class="page-ination">
          <a-pagination
            @change="pageChange"
            v-model="pageConent.pageNum"
            :defaultPageSize="pageConent.defaultPageSize"
            :total="pageConent.total"
            show-less-items
          />
        </div>
      </div>
      <!-- 上传审批文件 -->
      <uploadFilePop :isShow="isShow" @isShowEmit="isShowEmit"></uploadFilePop>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    dataIndex: "version",
    key: "version",
    title: "版本",
    ellipsis: true,
    width: 100,
    scopedSlots: { customRender: "version" }
  },
  {
    dataIndex: "resourceName",
    key: "resourceName",
    title: "流程文件名称",
    ellipsis: true,
    scopedSlots: { customRender: "resourceName" }
  },
  {
    dataIndex: "key",
    key: "key",
    ellipsis: true,
    title: "流程定义名称"
  },
  // {
  //   dataIndex: 'processDefinitionId',
  //   key: 'processDefinitionId',
  //   title: '流程定义ID',
  //   scopedSlots: { customRender: 'processDefinitionId' }
  // },
  {
    dataIndex: "deploymentId",
    key: "deploymentId",
    title: "部署ID",
    ellipsis: true,
    scopedSlots: { customRender: "deploymentId" }
  },
  {
    dataIndex: "appName",
    key: "appName",
    title: "业务名称",
    ellipsis: true,
    scopedSlots: { customRender: "appName" }
  },
  {
    dataIndex: "organizationName",
    key: "organizationName",
    title: "部门名称",
    ellipsis: true,
    scopedSlots: { customRender: "organizationName" }
  },
  {
    dataIndex: "operationbtn",
    key: "operationbtn",
    title: "操作",
    width: 200,
    scopedSlots: { customRender: "operationbtn" }
  }
];

const data = [];
import uploadFilePop from "./components/uploadfile-pop.vue";
import {
  getProcessDefinitions,
  delDefinition,
  uploadStreamAndDeployment
} from "./api/api";
export default {
  components: {
    uploadFilePop
  },
  data() {
    return {
      data,
      columns,
      labelCol: { span: 2 },
      wrapperCol: { span: 4 },
      form: {
        name: ""
      },
      isLoading: true,
      pageConent: {
        defaultPageSize: 10,
        pageNum: 1,
        total: 0
      },
      bfileList: [],
      dllFileList: [],
      isShow: false,
      headers: {
        Authentication: localStorage.getItem("token")
      }
    };
  },
  methods: {
    // 提交
    activitiSubmit() {},
    // 分页
    pageChange(page, pageSize) {
      this.getProcessDefinitionsFn();
    },
    // 默认查询activiti列表
    getProcessDefinitionsFn() {
      const params = {
        page: this.pageConent.pageNum,
        size: this.pageConent.defaultPageSize
      };
      getProcessDefinitions(params).then(res => {
        if (res.data.code === 0) {
          this.data = res.data.data;
          this.pageConent.total = res.data.count;
          this.isLoading = false;
        }
      });
    },
    // 配置
    activitiConfig(text, record) {
      // 获取xml参数
      // deploymentId=  record.deploymentId
      // resourceName=  record.resourceName
      // 获取所有用户节点
      // processDefinitionId=  record.processDefinitionId
      this.$router.push({
        path: "/activitiDetails",
        query: {
          deploymentId: record.deploymentId,
          resourceName: record.resourceName,
          processDefinitionId: record.processDefinitionId
        }
      });
    },
    // 删除审批流
    activitiDel(text, record) {
      this.$confirm({
        title: "您确认删除此条审批流吗？删除后将无法恢复?",
        okText: "确认",
        okType: "danger",
        cancelText: "取消",
        onOk: () => {
          const params = {
            deploymentId: record.deploymentId,
            processDefinitionId: record.processDefinitionId
          };
          this.$message.loading("删除中···", 0);
          delDefinition(params).then(res => {
            if (res.data.code === 0) {
              this.$message.destroy();
              this.$message.success("审批流删除成功！");
              this.getProcessDefinitionsFn();
            } else {
              this.$message.destroy();
              this.$message.error(res.data.msg);
              this.getProcessDefinitionsFn();
            }
          });
        },
        onCancel() {}
      });
    },
    // 上传文件部分
    uploadBtn() {
      this.isShow = true;
    },
    beforeUpload(file, fileList) {
      return false;
    },
    uploadFile(info) {
      this.dllFileList = info.fileList;
    },
    // 子组件传递 模态框 显示状态
    isShowEmit(res) {
      this.isShow = res;
      this.getProcessDefinitionsFn();
    },

    upgrade(file) {
      let formDataChildren = new FormData();
      formDataChildren.append("multipartFile", file.file);
      uploadStreamAndDeployment(formDataChildren).then(res => {
        if (res.data.code == 0) {
          this.$message.success("升级成功");
          this.getProcessDefinitionsFn();
        } else {
          this.$message.error("升级失败");
          this.getProcessDefinitionsFn();
        }
      });
    }
  },
  mounted() {
    // 默认查询activiti列表方法
    this.getProcessDefinitionsFn();
  }
};
</script>

<style lang="scss" scoped>
.oa-layout-content {
  height: auto;
  overflow: hidden;
  .search-flex {
    float: left;
    margin-right: 10px;
    line-height: 32px;
    .search-lable {
      min-width: 70px;
      float: left;
      text-align: right;
    }
    .a-input-70 {
      width: 160px !important;
    }
  }
  .activiti-btns {
    height: auto;
    overflow: hidden;
    // margin: 20px 0;
    margin-bottom: 20px;
  }
  .activiti-table {
    width: 100%;
    height: auto;
    overflow: hidden;
    margin: 20px 0;
  }
  /* 分页 */
  .page-ination {
    margin: 30px 0;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/activitiList/index.vue